import { render, staticRenderFns } from "./StateReportIssue.vue?vue&type=template&id=6924de60&scoped=true"
import script from "./StateReportIssue.vue?vue&type=script&lang=js"
export * from "./StateReportIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6924de60",
  null
  
)

export default component.exports